// Mirrors sge_infantil_core's utils/reportCard.js (MARK_RANGE_LEGEND/letterForPercent)
// so the UI can show the letter grade instantly while the user types, without
// waiting for a round-trip. Keep these two in sync if the mark ranges change.

export const MARK_RANGE_LEGEND = [
  { range: '90 – 100 / 80 – 89', grade: 'A* / A', description: 'HIGHEST LEVEL' },
  { range: '70 -79 / 60 -69 / 50 -59', grade: 'B / C / D', description: 'PASSING GRADE' },
  { range: '40 – 49', grade: 'E', description: 'BELOW STANDARD' },
  { range: '0 - 39', grade: 'U', description: 'UNGRADED' },
];

export function letterForPercent(pct) {
  if (pct === null || pct === undefined || pct === "" || isNaN(pct)) return null;
  const v = parseFloat(pct);
  if (v >= 90) return 'A*';
  if (v >= 80) return 'A';
  if (v >= 70) return 'B';
  if (v >= 60) return 'C';
  if (v >= 50) return 'D';
  if (v >= 40) return 'E';
  return 'U';
}

// The 4 fixed Cambridge evaluation categories, with their canonical display
// name and default weight — used by CadastrarAvaliacaoLayer to pre-fill the
// evaluation form. Both remain editable (Grade 10's 2nd trimestre uses
// different names/weights than Grade 9's 1st — see routes/evaluation.js'
// `category` field for why the aggregation doesn't depend on the name).
export const CAMBRIDGE_CATEGORIES = [
  { value: 'exam', label: 'Exams', defaultWeight: 50 },
  { value: 'progress', label: 'Progress Test', defaultWeight: 30 },
  { value: 'coursework', label: 'Course work', defaultWeight: 15 },
  { value: 'behaviour', label: 'Behaviour', defaultWeight: 5 },
];

export const COMPORTAMENTO_SUBJECT_NAME = 'Comportamento';
